export enum gameRulesAssetConfig {

    settings_ui = "assets/gamerules/settings_ui.json",
}